<!-- components/GuestBillingInfo.vue -->
<template>
  <BModal
    id="modal-tall"
    :model-value="modalDetail"
    scrollable
    centered
    title="Reservation Detail"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Reservation Invoice</h5>
        <!-- <div class="d-flex align-items-center">
            <span class="mr-2">17/02/2025 16:00:00</span>
            <div class="bg-success rounded-circle" style="width: 10px; height: 10px;"></div>
            <span>online: Ruth</span>
          </div> -->
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <div class="guest-info text-start" id="printArea">
      <!--  Kop & logo (print)  -->
      <div class="print-only" style="text-align: center; margin: 0; padding: 0">
        <table
          class="w-full border-collapse"
          style="width: 100%; border-collapse: collapse"
        >
          <tbody style="padding: 0; margin: 0">
            <tr class="border-b border-transparent">
              <td class="text-center" style="text-align: center">
                <img
                  src="../../../public/img/hotel-deliriver.png"
                  alt="Deli River Hotel Logo"
                  style="width: 50px; height: auto"
                />
              </td>
            </tr>
            <tr
              class="border-b border-transparent"
              style="padding: 0px; margin: 0px"
            >
              <td class="text-center">
                <h3 class="text-center">Deli River Hotel</h3>
                <p class="text-center">
                  Jl. Raya Namorambe No. 129, Medan, Indonesia
                </p>
                <p class="text-center">www.hotel-deliriver.com</p>
                <p class="text-center">contact@hotel-deliriver.com</p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <hr />
        <br />
        <p class="text-center"><strong>Reservation Invoice</strong></p>
      </div>

      <!-- <h4 class="print-only text-center">Reservation Invoice</h4> -->

      <div>
        <p class="text-secondary fw-semibold">Guest Information</p>
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left">Date</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ dateFormatter(data?.created_at) }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Res. Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.number ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Booking Source</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.source?.type ?? "-" }} -
                {{ data?.source?.name ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Guest</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.guest?.fullname ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left"></td>
              <td class="text-left"></td>
              <td class="text-left fw-semibold"></td>
            </tr>
            <!-- <tr class="screen-only border-b border-transparent">
                <td class="text-left">Contact</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  0{{ data?.reservation?.guest?.phone ?? "-" }}
                </td>
              </tr> -->
          </tbody>
        </table>
      </div>
      <br />
      <div>
        <!-- Print-only Table View -->
        <table
          class="w-full border-collapse print-only"
          style="width: 100%; border-collapse: collapse; font-size: 14px"
        >
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 6px">Booking ID</th>
              <th style="border: 1px solid #000; padding: 6px">Room</th>
              <th style="border: 1px solid #000; padding: 6px">Nights</th>
              <th style="border: 1px solid #000; padding: 6px">Price rate</th>
              <th style="border: 1px solid #000; padding: 6px">Disc</th>
              <th style="border: 1px solid #000; padding: 6px">Amount</th>
            </tr>
          </thead>

          <tbody>
            <!-- Single Reservation Item -->
            <tr>
              <td style="border: 1px solid #000; padding: 6px">
                {{ data?.number ?? "-" }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ data?.room?.room_category?.name ?? "-" }}
                <br />
                <small>
                  ({{ dateFormatter(data?.start) }}
                  to
                  {{ dateFormatter(data?.end) }})
                </small>
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ countDays(data?.start, data?.end) }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(data?.room_price ?? 0) }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ data?.discount ?? "0%" }}
              </td>

              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(data?.grand_total ?? 0) }}
              </td>
            </tr>

            <!-- Extra Charges (if any) -->
            <tr v-if="data?.extracharge?.filter((e) => e.quantity > 0)?.length">
              <td colspan="6" style="border: 1px solid #000; padding: 6px">
                <p>Included Extra Charges:</p>
                <p
                  v-for="(item, i) in data?.extracharge?.filter(
                    (e) => e.quantity > 0,
                  )"
                  :key="'e' + i"
                >
                  {{ item.extra_charge?.name }} ({{ item?.quantity }}x)
                  {{ formatIDR(item?.price ?? 0) }}
                </p>
              </td>
            </tr>

            <!-- TOTAL -->
            <tr style="font-weight: bold">
              <td
                colspan="5"
                style="border: 1px solid #000; padding: 6px; text-align: right"
              >
                Grand Total :
              </td>
              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(data?.grand_total ?? 0) }}
              </td>
            </tr>

            <!-- Down Payment -->
            <tr style="font-weight: bold">
              <td
                colspan="5"
                style="border: 1px solid #000; padding: 6px; text-align: right"
              >
                Down Payment :
              </td>
              <td style="border: 1px solid #000; padding: 6px">
                {{ formatIDR(data?.total_paid ?? 0) }}
              </td>
            </tr>

            <!-- Rest Payment -->
            <tr style="font-weight: bold">
              <td
                colspan="5"
                style="border: 1px solid #000; padding: 6px; text-align: right"
              >
                Rest Payment :
              </td>
              <td style="border: 1px solid #000; padding: 6px; color: red">
                {{ formatIDR(data?.outstanding_balance ?? 0) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="print-only mt-4">
        <br />
        <br />
        <p class="text-secondary fw-italic">
          Please kindly transfer the total amount to our account below :
        </p>
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left">Payment Method</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.payment_method?.type ?? "-" }}-{{
                  data?.payment_method?.name ?? "-"
                }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Account Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.payment_method?.number ?? "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Account Name</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ data?.payment_method?.owned_by ?? "-" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <!--  Tanda tangan (print) -->
      <div class="print-only" style="text-align: center; margin: 0; padding: 0">
        <div>
          <p><strong>Reservation Dept.</strong></p>
          <br /><br />

          <p>{{ adminData?.fullname ?? "Reservation Dept." }}</p>
          <p>______________________</p>
        </div>
        <!-- <div>
            <p>&nbsp;</p>
            <p><strong>Tamu</strong></p><br><br>
            <p>______________________</p>
          </div> -->
      </div>
    </div>

    <div>
      <p class="text-secondary fw-semibold billing-detail screen-only">
        Reservation Detail
      </p>

      <!-- Screen-only Table View (original) -->
      <table class="w-full text-left border-collapse table-billing screen-only">
        <tbody>
          <tr class="border-b border-transparent">
            <td class="text-left">Room Type</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ data?.room?.room_category?.name ?? "-" }}
            </td>
          </tr>
          <!-- <tr class="border-b border-transparent">
                <td class="text-left">Room Number</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ data?.room?.code ?? "-" }}
                </td>
              </tr> -->
          <tr class="border-b border-transparent">
            <td class="text-left">Check In</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ dateFormatter(data?.start) }}
            </td>
          </tr>
          <tr class="border-b border-transparent">
            <td class="text-left">Check Out</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ dateFormatter(data?.end) }}
            </td>
          </tr>
          <tr class="border-b border-transparent">
            <td class="text-left">Stay Duration</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ countDays(data?.start, data?.end) }}
            </td>
          </tr>
          <!-- //comment dulu karna pencocokan harga kamar normal & highseason -->
          <!-- <tr class="border-b border-transparent">
                <td class="text-left">Room Rate</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{
                    formatIDR(
                      data?.reservation?.room?.room_category?.low_season_price ??
                        0
                    )
                  }}
                </td>
              </tr> -->

          <!-- Extra Charge -->
          <tr class="border-b border-transparent align-top">
            <td class="text-left">Extra Charge</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              <div
                v-if="!data?.extracharge?.filter((e) => e.quantity > 0)?.length"
              >
                -
              </div>
              <div
                v-else
                v-for="(item, index) in data?.extracharge?.filter(
                  (e) => e.quantity > 0,
                )"
                :key="index"
              >
                {{ item.extra_charge?.name }} (Qty: {{ item.quantity }},
                {{ formatIDR(item?.price ?? 0) }})
              </div>
            </td>
          </tr>

          <!-- Payments -->
          <tr class="border-b border-transparent align-top">
            <td class="text-left">Payment</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              <div v-if="!data?.payment?.length">-</div>
              <div v-else v-for="(item, index) in data?.payment" :key="index">
                {{ item.payment_type }}
                ({{ formatIDR(item.amount ?? 0) }} at
                {{ getFormattedDate(item.payment_date) }})
              </div>
            </td>
          </tr>

          <tr class="border-b border-transparent">
            <td class="text-left">Status</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ data?.payment_status ?? "-" }}
            </td>
          </tr>
          <tr class="border-b border-transparent">
            <td class="text-left">Total</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ formatIDR(data?.grand_total ?? 0) }}
            </td>
          </tr>
          <tr class="print-only border-b border-transparent">
            <td class="text-left">Down Payment</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ formatIDR(data?.total_paid ?? 0) }}
            </td>
          </tr>
          <tr class="border-b border-transparent">
            <td class="text-left">Rest Payment</td>
            <td class="text-left">:</td>
            <td class="text-left fw-semibold">
              {{ formatIDR(data?.outstanding_balance ?? 0) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <template #footer>
      <div class="d-flex justify-content-end">
        <!-- Tombol cetak invoice biasa -->
        <BButton variant="warning" class="mr-2" @click="handlePrint"
          >Print</BButton
        >
        <BButton
          v-if="
            data?.extracharge?.filter((e) => Number(e.quantity) > 0)?.length
          "
          variant="info"
          class="mr-2"
          @click="handlePrintExtraCharge"
        >
          Print Extra Charge
        </BButton>

        <!-- <BButton variant="primary" @click="submitReservation"  class="mr-2">Save</BButton> -->
        <BButton variant="danger" @click="updateModal(false)">Close</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
//   defineProps({
//     data: Object,
//   })
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

import {
  BModal,
  BButton,
  // BRow,
  // BCol,
  // BForm,
  // BTabs,
  // BTab,
  // BFormInput,
  // BFormSelect,
  // BFormSelectOption,
  // BInputGroup,
  // BListGroup,
  // BListGroupItem,
  // BFormTextarea,
  // BFormRadioGroup
} from "bootstrap-vue-next";

export default {
  name: "CheckOutDetail",
  components: {
    BModal,
    BButton,
    // BRow,
    // BCol,
    // BForm,
    // BTabs,
    // BTab,
    // BFormInput,
    // BFormSelect,
    // BFormSelectOption,
    // BInputGroup,
    // BButton,
    // BListGroup,
    // BListGroupItem,
    // BFormTextarea,
    // BFormRadioGroup
  },

  props: {
    modal: Boolean,
    data: Object,
    title: { type: String, default: "Detail" },
    //modelValue:  { type: Boolean, default: false },
    adminData: {
      type: Object,
      default: null,
    },
  },

  emits: ["update:modal", "update:modelValue"],

  setup(props, { emit }) {
    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    return {
      formatIDR,
      dateFormatter,
      countDays,
      getFormattedDate,
      updateModal,
    };
  },

  computed: {
    hasExtraCharge() {
      return Boolean(
        this.data?.extracharge &&
          this.data.extracharge.filter((e) => Number(e.quantity) > 0).length >
            0,
      );
    },
  },

  methods: {
    formatCurrencyNumber(val) {
      const num = Number(val) || 0;
      return new Intl.NumberFormat("id-ID").format(num);
    },

    formatDateReceipt(dateInput) {
      if (!dateInput) return "-";
      const d = new Date(dateInput);
      if (isNaN(d.getTime())) return String(dateInput);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = String(d.getDate()).padStart(2, "0");
      const month = months[d.getMonth()];
      const year = String(d.getFullYear()).slice(-2);
      return `${day}-${month}-${year}`;
    },

    formatDateTimeReceipt(dateInput) {
      const d = dateInput ? new Date(dateInput) : new Date();
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = String(d.getDate()).padStart(2, "0");
      const month = months[d.getMonth()];
      const year = String(d.getFullYear()).slice(-2);
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    },

    handlePrintExtraCharge() {
      this.$nextTick(() => {
        const validCharges = (this.data?.extracharge || []).filter(
          (e) => Number(e.quantity) > 0,
        );

        if (!validCharges.length) {
          alert("Tidak ada data Extra Charge untuk dicetak.");
          return;
        }

        const guestName =
          this.data?.guest?.fullname ||
          this.data?.guest_name ||
          this.data?.guest?.name ||
          "-";

        const reservationNumber = this.data?.number || "-";
        const roomNumber = this.data?.room?.code || "-";
        const roomType = this.data?.room?.room_category?.name || "-";
        const checkInDate = this.formatDateReceipt(this.data?.start);
        const checkOutDate = this.formatDateReceipt(this.data?.end);
        const currentDate = this.formatDateTimeReceipt(new Date());

        const cashierName =
          this.adminData?.fullname ||
          this.adminData?.name ||
          this.adminData?.username ||
          "Cashier";

        let grandTotal = 0;
        let itemsHtml = "";

        validCharges.forEach((item, index) => {
          const itemName = item.extra_charge?.name || "Extra Charge";
          const qty = Number(item.quantity) || 1;
          const price = Number(item.price ?? item.extra_charge?.price ?? 0);
          const subtotal = qty * price;

          grandTotal += subtotal;

          itemsHtml += `
            <tr>
              <td style="text-align: center; border: 1px solid #000; padding: 8px;">${
                index + 1
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${itemName}</td>
              <td style="text-align: center; border: 1px solid #000; padding: 8px;">${qty}</td>
              <td style="text-align: right; border: 1px solid #000; padding: 8px;">Rp ${this.formatCurrencyNumber(
                price,
              )}</td>
              <td style="text-align: right; border: 1px solid #000; padding: 8px;">Rp ${this.formatCurrencyNumber(
                subtotal,
              )}</td>
            </tr>
          `;
        });

        const filename = `BILL-EXTRACHARGE-${reservationNumber}`;

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.setAttribute(
          "sandbox",
          "allow-modals allow-same-origin allow-scripts",
        );
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;

        doc.open();
        doc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>${filename}</title>
              <meta name="viewport" content="width=device-width,initial-scale=1.0">
              <style>
                @page {
                  size: A4 portrait;
                  margin: 8mm 15mm 0 15mm;
                }
                * {
                  box-sizing: border-box;
                }
                body {
                  font-family: Arial, sans-serif;
                  font-size: 11px;
                  color: #000;
                  background: #fff;
                  margin: 0;
                  padding: 0;
                  line-height: 1.3;
                }
                .text-center { text-align: center; }
                .text-right { text-align: right; }
                .text-left { text-align: left; }
                .fw-bold { font-weight: bold; }

                .header-table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 4px;
                }
                .header-table td {
                  vertical-align: middle;
                  border: none;
                  padding: 0;
                }
                .hotel-logo {
                  width: 50px;
                  height: auto;
                }
                .hotel-name {
                  font-size: 15px;
                  font-weight: bold;
                  letter-spacing: 0.5px;
                  margin-bottom: 2px;
                }
                .hotel-sub {
                  font-size: 10px;
                  color: #333;
                  margin: 0;
                  line-height: 1.25;
                }
                .header-divider {
                  border: none;
                  border-top: 1.5px solid #000;
                  margin: 6px 0 8px 0;
                }
                .doc-title {
                  text-align: center;
                  font-size: 13px;
                  font-weight: bold;
                  text-transform: uppercase;
                  letter-spacing: 1px;
                  margin-bottom: 8px;
                }

                .info-container {
                  width: 100%;
                  margin-bottom: 6px;
                }
                .info-table {
                  width: 100%;
                  border-collapse: collapse;
                  font-size: 11px;
                }
                .info-table td {
                  padding: 1.5px 0;
                  vertical-align: top;
                  border: none;
                }
                .info-label {
                  width: 105px;
                  color: #222;
                }
                .info-colon {
                  width: 12px;
                  text-align: center;
                }

                .items-table {
                  width: 100%;
                  border-collapse: collapse;
                  font-size: 11px;
                  margin-top: 4px;
                  margin-bottom: 6px;
                }
                .items-table th {
                  border: 1px solid #000;
                  background-color: #f2f2f2;
                  padding: 4px 6px;
                  font-weight: bold;
                  text-align: center;
                }
                .items-table td {
                  border: 1px solid #000;
                  padding: 4px 6px;
                }

                .signature-container {
                  width: 100%;
                  margin-top: 10px;
                  page-break-inside: avoid;
                }
                .footer-note {
                  text-align: center;
                  font-size: 10px;
                  font-style: italic;
                  margin-top: 8px;
                  color: #555;
                }
              </style>
            </head>
            <body>
              <!-- Kop Surat Resmi -->
              <table class="header-table">
                <tr>
                  <td style="width: 60px; text-align: center;">
                    <img src="/img/hotel-deliriver.png" alt="Deli River Hotel Logo" class="hotel-logo" />
                  </td>
                  <td style="padding-left: 12px;">
                    <div class="hotel-name">HOTEL DELI RIVER</div>
                    <div class="hotel-sub">Restaurant Omlandia</div>
                    <div class="hotel-sub">Jl. Raya Namorambe No. 129, Deli Tua, Medan, Sumatera Utara 20356</div>
                    <div class="hotel-sub">Tel: (061) 7032964 / 7032967 | Web: www.hotel-deliriver.com | Email: contact@hotel-deliriver.com</div>
                  </td>
                </tr>
              </table>

              <div class="header-divider"></div>

              <div class="doc-title">Extra Charge Bill</div>

              <!-- Detail Reservasi / Tamu -->
              <div class="info-container">
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <td style="width: 50%; vertical-align: top; border: none; padding-right: 15px;">
                      <table class="info-table">
                        <tr>
                          <td class="info-label">Guest Name</td>
                          <td class="info-colon">:</td>
                          <td class="fw-bold">${guestName}</td>
                        </tr>
                        <tr>
                          <td class="info-label">Res. Number</td>
                          <td class="info-colon">:</td>
                          <td class="fw-bold">${reservationNumber}</td>
                        </tr>
                        <tr>
                          <td class="info-label">Room Number</td>
                          <td class="info-colon">:</td>
                          <td>${roomNumber} ${
          roomType !== "-" ? `(${roomType})` : ""
        }</td>
                        </tr>
                      </table>
                    </td>
                    <td style="width: 50%; vertical-align: top; border: none; padding-left: 15px;">
                      <table class="info-table">
                        <tr>
                          <td class="info-label">Invoice Date</td>
                          <td class="info-colon">:</td>
                          <td>${currentDate}</td>
                        </tr>
                        <tr>
                          <td class="info-label">Check In</td>
                          <td class="info-colon">:</td>
                          <td>${checkInDate}</td>
                        </tr>
                        <tr>
                          <td class="info-label">Check Out</td>
                          <td class="info-colon">:</td>
                          <td>${checkOutDate}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>

              <!-- Tabel Item Extra Charge -->
              <table class="items-table">
                <thead>
                  <tr>
                    <th style="width: 40px;">No</th>
                    <th>Description / Item</th>
                    <th style="width: 80px;">Qty</th>
                    <th style="width: 140px;">Price</th>
                    <th style="width: 150px;">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  ${itemsHtml}
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" style="text-align: right; font-weight: bold; padding: 4px 6px; border: 1px solid #000; background-color: #f9f9f9;">
                      Grand Total
                    </td>
                    <td style="text-align: right; font-weight: bold; padding: 4px 6px; border: 1px solid #000; background-color: #f9f9f9;">
                      Rp ${this.formatCurrencyNumber(grandTotal)}
                    </td>
                  </tr>
                </tfoot>
              </table>

              <!-- Tanda Tangan -->
              <div class="signature-container">
                <table style="width: 100%; border-collapse: collapse; margin-top: 6px;">
                  <tr>
                    <td style="width: 50%; text-align: center; border: none; vertical-align: top;">
                      <div>Guest</div>
                      <div style="height: 28px;"></div>
                      <div>( ${guestName} )</div>
                    </td>
                    <td style="width: 50%; text-align: center; border: none; vertical-align: top;">
                      <div>Front Office</div>
                      <div style="height: 28px;"></div>
                      <div>( ${cashierName} )</div>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="footer-note">
                Thank you for visiting Deli River Hotel & Restaurant Omlandia
              </div>
            </body>
          </html>
        `);
        doc.close();

        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setTimeout(() => {
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
          }, 1000);
        };
      });
    },

    handlePrint() {
      this.$nextTick(() => {
        const printContents = document.getElementById("printArea").innerHTML;
        const bookingNumber = this.data?.number || "unknown";

        const now = new Date();
        const pad = (num) => String(num).padStart(2, "0");
        const formattedDate = `${now.getFullYear()}-${pad(
          now.getMonth() + 1,
        )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
          now.getMinutes(),
        )}-${pad(now.getSeconds())}`;
        const filename = `invoice-HDR-${bookingNumber}-${formattedDate}`;

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.setAttribute(
          "sandbox",
          "allow-modals allow-same-origin allow-scripts",
        );
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;

        doc.open();
        doc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>${filename}</title>
              <meta name="viewport" content="width=device-width,initial-scale=1.0">
              <style>
                @media print
                {
                  @page {
                    size: 80mm auto;    
                  }
                  body {
                    font-family: sans-serif;
                    font-size: 14px;
                    margin: 10px;
                    padding: 0;
                  }
                  h2 {
                    font-size: 10px;
                    margin: 0;
                  }
                  h3 {
                    margin: 0;
                  }
                  h4 {
                    margin: 0;
                  }
                  p {
                    margin: 3px 0px;
                  }
                  .billing-detail {
                    margin-top: -5px;
                  }
                  hr {
                    margin-top: -5px;
                  }
                  tbody {
                    margin: 0px;
                  }
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        doc.close();

        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setTimeout(() => {
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
          }, 1000);
        };
      });
    },
  },
};
</script>
